// routes
import { ROOTS } from '../routes/paths';
// utils
import axios from '../utils/axios';

// ----------------------------------------------------------------------

export const getPayload = (accessToken) => {
  return  jwtDecode(accessToken);
}

// ----------------------------------------------------------------------

function jwtDecode(token) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join('')
  );

  return JSON.parse(jsonPayload);
}

// ----------------------------------------------------------------------

export const isValidToken = (accessToken) => {
  if (!accessToken) {
    return false;
  }

  const decoded = jwtDecode(accessToken);

  const currentTime = Date.now() / 1000;
  const isValid = decoded.exp > currentTime;
  if (!isValid) localStorage.removeItem('accessToken');

  return isValid;
};

// ----------------------------------------------------------------------

function dateDiff(date1, date2) {
	var diff = {}							// Initialisation du retour
	var tmp = date2 - date1;

	tmp = Math.floor(tmp/1000);             // Nombre de secondes entre les 2 dates
	diff.sec = tmp % 60;					// Extraction du nombre de secondes

	tmp = Math.floor((tmp-diff.sec)/60);	// Nombre de minutes (partie entière)
	diff.min = tmp % 60;					// Extraction du nombre de minutes

	tmp = Math.floor((tmp-diff.min)/60);	// Nombre d'heures (entières)
	diff.hour = tmp % 24;					// Extraction du nombre d'heures
	
	tmp = Math.floor((tmp-diff.hour)/24);	// Nombre de jours restants
	diff.day = tmp;
	
	return diff;
}

export const tokenExpired = (exp) => {
  // eslint-disable-next-line prefer-const
  let expiredTimer;

  const currentTime = Date.now();
  var currentDate = new Date(currentTime);
  var expDate = new Date(exp*1000); // var expDate = new Date(1702478898*1000);
  let diff = dateDiff(currentDate, expDate)

  let diffTimeLog = "Temps restant avant expiration du token : " + diff.day + " jours, " + diff.hour + " heures, " + diff.min + " minutes et " + diff.sec + " secondes";
  localStorage.setItem('diffTimeLog', diffTimeLog)
  // console.log("diffTimeLog : ", diffTimeLog);

  const milliseconds = (d, h, m, s) => ((d*24+h*60*60+m*60+s)*1000);
  const timeLeftMS = milliseconds(diff.day, diff.hour, diff.min, diff.sec);
  localStorage.setItem('timeLeftMS', timeLeftMS)
  // console.log("timeLeftMS :", timeLeftMS);

  clearTimeout(expiredTimer);

  expiredTimer = setTimeout(() => {
    localStorage.removeItem('accessToken');
    localStorage.setItem('tokenEnd', true);
    window.location.href = ROOTS.root; // renvoi sur la base, si pas authen, j'irais direct sur le login
  }, timeLeftMS);
};

// ----------------------------------------------------------------------

export const setSession = (accessToken) => {
  if (accessToken) {
    localStorage.setItem('accessToken', accessToken);

    axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
    // axios.defaults.headers.common.X-rainbow-token = `Bearer ${accessToken}`; //! faut que je mette ce headert

    // This function below will handle when token is expired
    const { exp } = jwtDecode(accessToken); //! 1h logiquement mais au final 10 minutes d'après ce que je vois
    tokenExpired(exp);
    
  } else {
    localStorage.removeItem('accessToken');

    delete axios.defaults.headers.common.Authorization;
  }
};

// export const getBigConfig = async (accessToken) => {
//   const response = await myAxios.get('/oauth/callback', {data: {token: state.token, userId: state.user.id}});
//   return response;
// };